import {
  AuthenticatedUserSuggestion,
  AuthenticatedUserSuggestionParams,
  EventHistory,
} from './types';
import { globalGetService } from '@/utils/globalApiServices';
import { getTimezone } from '@/utils/time';
import { Pagination } from '@/utils/types';

export const getEventHistory = async (params: Record<string, any>) => {
  const response = await globalGetService('csp/event', {
    ...params,
    timezone: getTimezone(),
  });
  return response?.ok ? (response.data as Pagination<EventHistory>) : undefined;
};

export const downloadEventHistoryAsCsv = async (
  params: Record<string, unknown>
) => {
  const response = await globalGetService(
    'csp/event/csv',
    {
      ...params,
      timezone: getTimezone(),
    },
    'arraybuffer'
  );
  return response?.ok ? (response.data as ArrayBuffer) : undefined;
};

export const getAuthenticatedUserSuggestions = async (
  params: AuthenticatedUserSuggestionParams
) => {
  const response = await globalGetService(
    'csp/event/suggestion/authenticatedUser',
    params
  );
  return (response?.ok ? response.data : []) as AuthenticatedUserSuggestion[];
};
